// Shared Imports
import { IEnvironment, EEnvironment } from '@shared/models'

export const environment: IEnvironment = {
	production: false,
	operationGatewayMexico: 'https://testzeegw.vemoit.com/oms/mex',
	gateway: 'https://testzeegw.vemoit.com',
	environment: EEnvironment.test,
	signinRedirectUrl: 'https://testzeeoperation.vemoit.com',
	signoutRedirectUrl: 'https://testzeeoperation.vemoit.com/logout',
}
